import React from 'react'
import { Chip, Tooltip } from '@mui/material'

export function formatMmSs(totalSeconds: number) {
  const s = Math.max(0, Math.floor(Math.abs(totalSeconds)))
  const mm = String(Math.floor(s / 60)).padStart(2, '0')
  const ss = String(s % 60).padStart(2, '0')
  return `${mm}:${ss}`
}

interface StatusChipProps {
  driftSeconds?: number
}

const StatusChip: React.FC<StatusChipProps> = ({ driftSeconds = 0 }) => {
  const abs = Math.abs(driftSeconds)
  let color: 'default' | 'success' | 'error' | 'warning' = 'default'
  let label = 'On time'

  if (abs <= 60) {
    color = 'success'
    label = 'On time'
  } else if (driftSeconds > 60) {
    color = 'error'
    label = `Behind by ${formatMmSs(driftSeconds)}`
  } else {
    color = 'warning'
    label = `Ahead by ${formatMmSs(driftSeconds)}`
  }

  return (
    <Tooltip title="Schedule status based on station-local projection">
      <Chip
        color={color}
        label={label}
        size="medium"
        sx={{
          '& .MuiChip-label': {
            fontSize: '1.25rem',
            fontWeight: 700,
            lineHeight: 1.1,
            px: 2,
            py: 0.85,
          },
        }}
      />
    </Tooltip>
  )
}

export default StatusChip
